import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-stone-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Footer Links */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-8 md:mb-12">
          <Link to="/imprint" className="hover:text-gray-800 transition-colors whitespace-nowrap text-sm md:text-base">
            LEGAL NOTICE
          </Link>
          <Link to="/privacy" className="hover:text-gray-800 transition-colors whitespace-nowrap text-sm md:text-base">
            PRIVACY POLICY
          </Link>
        </div>

        {/* Tagline */}
        <div className="text-center px-4">
          <p className="text-xs md:text-sm uppercase tracking-wider text-gray-600">
            A creative photographic signature, between timelessness and Parisian refinement
          </p>
        </div>
      </div>
    </footer>
  );
}
